export default __webpack_public_path__ + "static/media/sirim-1573.ec548385.png";